import { useEffect, useRef } from 'react'

import { useTranslation } from 'react-i18next'

import { DataHubService } from 'src/modules/datahub'
import { LimitPublicationSchema } from 'src/modules/datahub/schemas/settings'

import { useSettings } from '../../hooks/useSettings'

import '@hotmart/cosmos/dist/form/form.css'
import '@hotmart/cosmos/dist/form/input-custom.css'
import '@hotmart/cosmos/dist/form/input-switch.css'

const LimitPublicationsSwitch = () => {
  const { t } = useTranslation()
  const limitPublicationsSwitchRef = useRef<HTMLInputElement>(null)
  const { setIsCollaborativeContent, isCollaborativeContent } = useSettings()

  const handleLimitPublicationsSwitchChange = () => {
    setIsCollaborativeContent(limitPublicationsSwitchRef.current?.checked ? false : true)

    const schema = new LimitPublicationSchema()

    DataHubService.sendEvent({ schema })
  }

  useEffect(() => {
    if (!limitPublicationsSwitchRef?.current) return

    if (isCollaborativeContent === false) {
      limitPublicationsSwitchRef.current.checked = true

      return
    }

    limitPublicationsSwitchRef.current.checked = false
  }, [isCollaborativeContent])

  return (
    <>
      <div className='_border _rounded-lg _py-3 _px-5 _d-flex _align-items-center'>
        <div className='_mr-4'>
          <span className='_d-block _mb-1 _line-height _text-gray-900'>
            {t('limit_publications.title', { ns: 'settings' })}
          </span>

          <span className='_text-1 _line-height _text-gray-900'>
            {t('limit_publications.description', { ns: 'settings' })}
          </span>
        </div>

        <div className='_ml-auto hot-form-group'>
          <div className='hot-form hot-form--custom hot-form--switch'>
            <input
              ref={limitPublicationsSwitchRef}
              onChange={handleLimitPublicationsSwitchChange}
              type='checkbox'
              className='hot-form__input'
              id='read-only-community-switch'
            />

            <label className='hot-form__label' htmlFor='read-only-community-switch'>
              <span className='_sr-only'> {t('limit_publications.title', { ns: 'settings' })}</span>
            </label>
          </div>
        </div>
      </div>
    </>
  )
}

export default LimitPublicationsSwitch
